<div [ngClass]="deviceService.isZoomContent | async">
  <router-outlet></router-outlet>
  <div class='note-container'>
    <ng-template #container></ng-template>
  </div>
</div>